import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BannerSearchRequestBody, BannerSearchResponse } from "./types";

export class BannerSearchAPI extends BaseAPI<
  BannerSearchRequestBody,
  BannerSearchResponse
> {
  protected route = ApiRoutes.banner.search;
  protected method = RequestMethod.POST;
}
